import { Box, Paper, Stack, Text } from "@mantine/core"
import type { IProps } from "./interfaces"
import classes from "./styles.module.css"

/**
 * Centered state card for empty / error / no-results screens — a tinted icon
 * badge, a title, an optional description, and an optional action. Pure
 * presentation; the tone (brand / danger / neutral) rides a `data-tone`
 * attribute so the palette swap stays in CSS, never string-concatenated.
 */
export const EmptyState = ({ icon, title, description, action, tone = "brand" }: IProps): React.JSX.Element => (
  <Paper withBorder radius="lg" className={classes.card}>
    <Stack align="center" gap="sm" maw={420} mx="auto" w="100%">
      <Box className={classes.badge} data-tone={tone}>
        {icon}
      </Box>
      <Text fw={600} size="lg" ta="center">
        {title}
      </Text>
      {description ? (
        <Text c="dimmed" size="sm" ta="center">
          {description}
        </Text>
      ) : null}
      {action ? <Box mt="xs">{action}</Box> : null}
    </Stack>
  </Paper>
)
